import qs from 'qs';
import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getPaymentFailures = serviceBase({
  request: options =>
    axiosClient.get('automatic-debit', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }),
  retry: 0
});

export const cancelPayment = serviceBase({
  request: id => axiosClient.put(`automatic-debit/${id}/cancel`),
  retry: 0
});

export const editPaymentDueDate = serviceBase({
  request: ({ id, dueDate }) => {
    return axiosClient.put(`automatic-debit/${id}/due-date`, {
      dueDate: new Date(dueDate)
    });
  },
  retry: 0
});

export const generateAutomaticDebitFormats = serviceBase({
  request: () => {
    return axiosClient.post(`cron/automatic-debit`, undefined, { timeout: 120000 });
  },
  retry: 0
});

export const sendToBillPayment = serviceBase({
  request: id => axiosClient.put(`automatic-debit/charge-payment/${id}`),
  retry: 0
});

export const downloadExportedAutomaticDebits = serviceBase({
  request: options =>
    axiosClient.get('/automatic-debit/export', {
      responseType: 'blob',
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'CobranzasDomiciliadas.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});

export const createAutomaticDebit = serviceBase({
  request: values => {
    return axiosClient.post('automatic-debit', values);
  },
  retry: 0
});

export const reactivateAutomaticDebit = serviceBase({
  request: ({ id, dueDate }) => {
    return axiosClient.put(`automatic-debit/${id}/reactivate`, {
      dueDate: new Date(dueDate)
    });
  },
  retry: 0
});

export const editAutomaticDebitAmount = serviceBase({
  request: ({ id, transactionId, amount }) => {
    return axiosClient.put(`automatic-debit/${id}`, { transactionId, amount });
  },
  retry: 0
});

export const getContractPendingAutomaticDebits = serviceBase({
  request: contractId =>
    axiosClient.get('automatic-debit', {
      params: { contractId, status: 'PENDING', limit: 1 }
    }),
  retry: 0
});

export const sendCreditCardPaymentLink = serviceBase({
  request: ({ clientId, invoices }) => {
    return axiosClient.post(`/payment/credit-card-payment-link`, {
      clientId,
      invoices
    });
  },
  retry: 0
});
